import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const PriceDevelopmentIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container icon-container-price-development' data-testid='price-development-icon'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/120df7c985d227fd75adab213f6bf8ba_IS24_Price_Development_Icon.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/3edda9d58fb020127c37fe2991c75b33_IS24_Price_Development_Icon@2x.png 2x, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/f722ba57c5a270e19117b1d293a23e69_IS24_Price_Development_Icon@3x.png 3x'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/120df7c985d227fd75adab213f6bf8ba_IS24_Price_Development_Icon.png'
        }
        alt='price-development'
      />
    </div>
  )
}
